import React from 'react';
import Icon from '../../../icon';
import Flag from '../../../flag';
import { OPTION_TYPE } from '../../types';

const defaultIcon = {};
const defaultFlag = {};
const defaultFormatLabel = (label) => label;

const BaseOption = ({
  value,
  label,
  icon = defaultIcon,
  flag = defaultFlag,
  note = '',
  formatLabel = defaultFormatLabel,
}) => (
  <div className="ws-ui-base-select-option" key={value}>
    {!!icon.glyph && (
      <div className="ws-ui-base-select-option__icon">
        <Icon {...icon} />
      </div>
    )}
    {!!flag.code && !icon.glyph && (
      <div className="ws-ui-base-select-option__flag">
        <Flag {...flag} />
      </div>
    )}
    <div className="ws-ui-base-select-option__label">{formatLabel(label)}</div>
    {!!note && <div className="ws-ui-base-select-option__note">{note}</div>}
  </div>
);

BaseOption.propTypes = OPTION_TYPE;

export default BaseOption;
